import { Outlet } from 'react-router-dom';
import { TpmProvider } from 'pages/tpm';

function TpmProviderWrapper() {
    return (
        <TpmProvider>
            <Outlet />
        </TpmProvider>
    );
}

export default TpmProviderWrapper;
